import { Injectable } from '@angular/core';
import { IMenuItem } from './menu-item.interface';

import * as _ from 'lodash';

@Injectable()
export class MenuService {
  constructor() {
  }

  public getMenuWithRoles(menuItems: IMenuItem[], roles: string[]): IMenuItem[] {
    // Filter menu items at the same level.
    const allowedMenuItems = menuItems.filter(
      (menuItem) => {
        // No role specified: public menu item
        if (!menuItem.allowedRoles) {
          return true;
        }

        // Empty-array role: not allowed for any role.
        if (!menuItem.allowedRoles.length) {
          return false;
        }

        const matchedRoles = _.intersection(
          menuItem.allowedRoles.map(role => role.trim().toLowerCase()),
          roles.map(role => role.trim().toLowerCase()),
        );

        return matchedRoles && matchedRoles.length;
      },
    );

    // Dig one-level deeper for each menu item.
    allowedMenuItems.forEach(
      (menuItem) => {
        if (!menuItem.children || !menuItem.children.length) {
          return true;
        }

        menuItem.children = this.getMenuWithRoles(menuItem.children, roles);
      },
    );

    return allowedMenuItems;
  }
}
